import React from "react";
import { connect } from "react-redux";
import { Accordion, Button, List } from "devextreme-react";
import SelectField from "../../../../../Shared/fields/SelectField";
import TableTabs from "../../../../../Shared/tableTabs";
import { setDataSelected } from "../actions";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import { openCloseToast } from "../../../../../Global/actions";

class EditBaterias extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      indexTable: 0,
    };
  }

  getDefaultCity = (c) => {
    if (!c) return null;
    const city = c && c.map((e, i) => e.selected ? e.Id : null).filter((f) => f);
    if (!city.length) {
      return this.props.dataSelected.defaultCityId;
    }
    return city[0] ? city[0] : null;
  }

  showToastr = (msg, type) => this.props.dispatch(openCloseToast({
    isToastOpen: true,
    msgToast: msg,
    typeStyle: type,
    displayTime: 5000,
  }));

  handleChange = (e) => {
    const { dataSelected } = this.props;
    const data = { ...dataSelected };

    const selectOffice = (officeList, idCity) => {
      let hasCity = false;
      const office = officeList.map((c) => {
        c.selected = c.Id === idCity;
        if (c.Id === idCity) {
          hasCity = true;
        }
        return c;
      });
      if (!hasCity) {
        this.showToastr("Debe indicar la ciudad o agencia", "warning");
      }

      return office;
    };

    const selectCentro = (list, id, idCity) => {
      if (!id) return list;
      return list.map((b) => {
        if (`${b.Id}` === id) { b.AchsOffices = selectOffice(b.AchsOffices, idCity); }
        return b;
      });
    };

    const validateListExams = (list) => {
      return [...list, e.itemData];
      let validatedList = [];
      if (data.Pools.length === 0 && data.AdditionalExams.length === 0 && data.PsychologicalExams.length === 0 && !data.defaultCityId) {
        validatedList = [...list, e.itemData];
      } else if (data.defaultCityId) {
        e.itemData.AchsOffices = selectOffice(e.itemData.AchsOffices, data.defaultCityId);
        validatedList = [...list, e.itemData];
      } else {
        this.showToastr("Debe indicar la ciudad o agencia, para poder agregar un nuevo elemento", "error");
      }

      return validatedList;
    };

    const splitName = e.element.id.split("_");
    const typeCity = splitName[1] ? splitName[1] : null;

    let type = e.element.id;
    if (e.element.id.includes("ciudadSelected")) {
      type = typeCity;
    }

    switch (type) {
      case "baterias-add": {
        data.isPoolsUpdate = true;
        data.Pools = validateListExams(data.Pools);
        break;
      }
      case "baterias": {
        data.isPoolsUpdate = true;
        if (!data.defaultCityId) data.defaultCityId = e.value;
        data.Pools = selectCentro([...data.Pools], (splitName[2] ? splitName[2] : null), e.value);
        break;
      }
      case "examenesAdicionales-add": {
        data.isExamsUpdate = true;
        data.AdditionalExams = validateListExams(data.AdditionalExams);
        break;
      }
      case "adicionales": {
        data.isExamsUpdate = true;
        if (!data.defaultCityId) data.defaultCityId = e.value;
        data.AdditionalExams = selectCentro([...data.AdditionalExams], (splitName[2] ? splitName[2] : null), e.value);
        break;
      }
      case "examenesPsicologicos-add": {
        data.isExamsUpdate = true;
        data.PsychologicalExams = validateListExams(data.PsychologicalExams);
        break;
      }
      case "psicologicos": {
        data.isExamsUpdate = true;
        if (!data.defaultCityId) data.defaultCityId = e.value;
        data.PsychologicalExams = selectCentro([...data.PsychologicalExams], (splitName[2] ? splitName[2] : null), e.value);
        break;
      }
      default:
        return;
    }

    this.props.dispatch(setDataSelected(data));
  }

  handleTabChange = (e) => {
    this.setState({ indexTable: e });
  }

  removeExamen = (e, data, type) => {
    const { dataSelected } = this.props;
    const newData = { ...dataSelected };
    switch (type) {
      case "bateria": {
        newData.isPoolsUpdate = true;
        newData.Pools = newData.Pools.filter((t) => t.Id !== data.Id);
        break;
      }
      case "adicional": {
        newData.isExamsUpdate = true;
        newData.AdditionalExams = newData.AdditionalExams.filter((t) => t.Id !== data.Id);
        break;
      }
      case "psicologico": {
        newData.isExamsUpdate = true;
        newData.PsychologicalExams = newData.PsychologicalExams.filter((t) => t.Id !== data.Id);
        break;
      }
      default:
        break;
    }

    this.props.dispatch(setDataSelected(newData));
  }

  CustomItem = (data, tipo) => (
    <div id={`titleTooltip_${data.Id}`}>
      <SelectField
        label="Ciudad o agencia de la evaluación"
        displayExpr="Description"
        valueExpr="Id"
        dataSource={data.AchsOffices}
        searchEnabled
        dropdownMaxHeight={300}
        id={`ciudadSelected_${tipo}_${data.Id}`}
        value={this.getDefaultCity(data.AchsOffices)}
        onValueChanged={(value) => this.handleChange(value, data.Id)}
      />
    </div>
  );

  renderTabBatery = () => {
    let listaBateriasFiltrada = [];
    if (this.props.dataSelected && !this.props.dataSelected.Pools) return listaBateriasFiltrada;
    if (!this.props.dataSelected.Pools.length) {
      listaBateriasFiltrada = this.props.listaBaterias.filter((e) => e.AchsOffices.find(ee => this.props.dataSelected.defaultCityId === ee.Id));
    } else {
      listaBateriasFiltrada = this.props.listaBaterias.filter((i) => i.AchsOffices.find(ee => this.props.dataSelected.defaultCityId === ee.Id) && this.props.dataSelected.Pools.every((b) => b.Id !== i.Id));
    }

    return (
      <div style={{ marginTop: 10 }}>
        <div className="row">
          <div className="col-12" style={{ marginBottom: 10 }}>
            <SelectField
              validation={false}
              label="Bateria de exámenes"
              displayExpr="Description"
              valueExpr="Id"
              dataSource={listaBateriasFiltrada}
              searchEnabled
              id="baterias-add"
              onItemClick={this.handleChange}
              value={this.props.dataSelected.Pools.length > 0 ? this.props.dataSelected.Pools[this.props.dataSelected.Pools.length - 1].Id : null}
            />
          </div>
        </div>
        <div className="row zero">
          <div className="col-12 zero accordion-wrapper">
            <List
              noDataText=""
              activeStateEnabled={false}
              focusStateEnabled={false}
              hoverStateEnabled={false}
              id="acordion_bateria"
              className={this.props.dataSelected.Pools && this.props.dataSelected.Pools.length > 0 ? "accordion bateria" : "accordion"}
              dataSource={this.props.dataSelected.Pools}
              itemRender={(data) => (
                <div className="titleContent">
                  <h4>{data.Description}</h4>
                  <Button icon="close" stylingMode="text" onClick={(e) => this.removeExamen(e, data, "bateria")} />
                </div>
              )}
              //itemComponent={(d, index) => this.CustomItem(d, "baterias", index)}
            />
          </div>
        </div>
      </div>
    );
  }

  renderTabExams = () => {
    let listaExamenesFiltrada = [];
    if (!this.props.dataSelected.AdditionalExams) return listaExamenesFiltrada;
    if (!this.props.dataSelected.AdditionalExams.length) {
      listaExamenesFiltrada = this.props.listaExamenes.filter(e => e.AchsOffices.find(ee => this.props.dataSelected.defaultCityId === ee.Id));
    } else {
      listaExamenesFiltrada = this.props.listaExamenes.filter((i) => i.AchsOffices.find(ee => this.props.dataSelected.defaultCityId === ee.Id) && this.props.dataSelected.AdditionalExams.every((b) => b.Id !== i.Id));
    }

    return (
      <div style={{ marginTop: 10 }}>
        <div className="row">
          <div className="col-12" style={{ marginBottom: 10 }}>
            <SelectField
              label="Prestaciones médicas"
              displayExpr="Description"
              valueExpr="Id"
              dataSource={listaExamenesFiltrada}
              searchEnabled
              id="examenesAdicionales-add"
              onItemClick={this.handleChange}
              value={this.props.dataSelected.AdditionalExams.length > 0 ? this.props.dataSelected.AdditionalExams[this.props.dataSelected.AdditionalExams.length - 1].Id : null}
            />
          </div>
        </div>
        <div className="row zero">
          <div className="col-12 zero accordion-wrapper">
            <List
              noDataText=""
              activeStateEnabled={false}
              focusStateEnabled={false}
              hoverStateEnabled={false}
              className={this.props.dataSelected.AdditionalExams && this.props.dataSelected.AdditionalExams.length > 0 ? "accordion adicional" : "accordion"}
              dataSource={this.props.dataSelected.AdditionalExams}
              itemRender={(data) => (
                <div className="titleContent">
                  <h4>{data.Description}</h4>
                  <Button icon="close" stylingMode="text" onClick={(e) => this.removeExamen(e, data, "adicional")} />
                </div>
              )}
              //itemComponent={(d) => this.CustomItem(d, "adicionales")}
            />
          </div>
        </div>
      </div>
    );
  }

  renderTabPsico = () => {
    let listaExamenesPsicologicosFiltrada = [];
    if (!this.props.dataSelected.PsychologicalExams) return listaExamenesPsicologicosFiltrada;
    if (!this.props.dataSelected.PsychologicalExams.length) {
      listaExamenesPsicologicosFiltrada = this.props.listaExamenesPsicologicos.filter(e => e.AchsOffices.find(ee => this.props.dataSelected.defaultCityId === ee.Id));
    } else {
      listaExamenesPsicologicosFiltrada = this.props.listaExamenesPsicologicos.filter((i) => i.AchsOffices.find(ee => this.props.dataSelected.defaultCityId === ee.Id) && this.props.dataSelected.PsychologicalExams.every((b) => b.Id !== i.Id));
    }
    return (
      <div style={{ marginTop: 10 }}>
        <div className="row">
          <div className="col-12" style={{ marginBottom: 10 }}>
            <SelectField
              label="Evaluación  psicológica"
              displayExpr="Description"
              valueExpr="Id"
              dataSource={listaExamenesPsicologicosFiltrada}
              searchEnabled
              id="examenesPsicologicos-add"
              onItemClick={this.handleChange}
              value={this.props.dataSelected.PsychologicalExams.length > 0 ? this.props.dataSelected.PsychologicalExams[this.props.dataSelected.PsychologicalExams.length - 1].Id : null}
            />
          </div>
        </div>

        <div className="row zero">
          <div className="col-12 zero accordion-wrapper">
            <List
              noDataText=""
              activeStateEnabled={false}
              focusStateEnabled={false}
              hoverStateEnabled={false}
              className={this.props.dataSelected.PsychologicalExams && this.props.dataSelected.PsychologicalExams.length > 0 ? "accordion adicional" : "accordion"}
              dataSource={this.props.dataSelected.PsychologicalExams}
              itemRender={(data) => (
                <div className="titleContent">
                  <h4>{data.Description}</h4>
                  <Button icon="close" stylingMode="text" onClick={(e) => this.removeExamen(e, data, "psicologico")} />
                </div>
              )}
              //itemComponent={(d) => this.CustomItem(d, "psicologicos")}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="row agendaSel">
        {this.props.isLoading && <LoadingOverlay />}
        <div className="row solicitudExamen tabs-wrapper">
          <div className="col-12">
            <TableTabs
              index={this.state.indexTable}
              changeTabCallback={this.handleTabChange}
              scrollByContent
              showNavButtons={false}
              tabs={[
                {
                  disabled: this.state.disableBateryTab,
                  contentId: 0,
                  index: 0,
                  Name: "Baterías",
                  Number: this.props.dataSelected && this.props.dataSelected.Pools ? this.props.dataSelected.Pools.length : 0,
                },
                {
                  disabled: this.state.disableExamsTab,
                  contentId: 1,
                  index: 1,
                  Name: "Prestaciones médicas",
                  Number: this.props.dataSelected && this.props.dataSelected.AdditionalExams ? this.props.dataSelected.AdditionalExams.length : 0,
                },
                {
                  disabled: this.state.disablePsicoTab,
                  contentId: 2,
                  index: 2,
                  Name: "Evaluación  psicológica",
                  Number: this.props.dataSelected && this.props.dataSelected.PsychologicalExams ? this.props.dataSelected.PsychologicalExams.length : 0,
                },
              ]}
            />
          </div>

          <div className="col-12">
            {this.state.indexTable === 0 && this.renderTabBatery()}
            {this.state.indexTable === 1 && this.renderTabExams()}
            {this.state.indexTable === 2 && this.renderTabPsico()}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  isLoading: state.confirmacionSolicitudesAgendaSel.isLoading,
  dataSelected: state.confirmacionSolicitudesAgendaSel.dataSelected,
  listaBaterias: state.solicitudesAgendaSel.listaBaterias,
  listaExamenes: state.solicitudesAgendaSel.listaExamenes,
  listaExamenesPsicologicos: state.solicitudesAgendaSel.listaExamenesPsicologicos,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditBaterias);
